function debounce(cb, ms) {
    var timer = null;
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var onComplete = function () {
            cb.apply(_this, args);
            timer = null;
        };
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(onComplete, ms);
    };
}
var install = function (Vue) {
    Vue.prototype.$onResize = function (callback, debounceTimeout) {
        if (debounceTimeout === void 0) { debounceTimeout = 250; }
        var handler = function (evt) {
            return callback(window.innerWidth, window.innerHeight, evt);
        };
        var debouncedHandler = debounce(handler, debounceTimeout);
        var remove = function () {
            window.removeEventListener('resize', debouncedHandler);
        };
        window.addEventListener('resize', debouncedHandler);
        this.$once('hook:beforeDestroy', remove);
        function fire() {
            callback(window.innerWidth, window.innerHeight);
            return { fire: fire, remove: remove };
        }
        return { fire: fire, remove: remove };
    };
};
export var Plugin = {
    install: function (Vue) { return install(Vue); }
};
export default Plugin;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sparing-software/vue-on-resize/dist/esm/index.js
// module id = 4f1b
// module chunks = 0